module.exports = __webpack_public_path__ + "static/village-5561af992dd82ab0bd53832da7abcbc9.jpg";